"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideDeviceInfoOverlay = exports.showDeviceInfoOverlay = exports.hideGenericTicketDetailsOverlay = exports.showGenericTicketDetailsOverlay = void 0;
var typesafe_actions_1 = require("typesafe-actions");
exports.showGenericTicketDetailsOverlay = (0, typesafe_actions_1.createStandardAction)('SIDEBAR_GENERIC_TICKET_DETAILS_OVERLAY_SHOW')();
exports.hideGenericTicketDetailsOverlay = (0, typesafe_actions_1.createStandardAction)('SIDEBAR_GENERIC_TICKET_DETAILS_OVERLAY_HIDE')();
exports.showDeviceInfoOverlay = (0, typesafe_actions_1.createStandardAction)('SIDEBAR_DEVICE_INFO_OVERLAY_SHOW')();
exports.hideDeviceInfoOverlay = (0, typesafe_actions_1.createStandardAction)('SIDEBAR_DEVICE_INFO_OVERLAY_HIDE')();